<template id="mCartProduct">
<div class="fullsection">
  <div class="proDesc">
    <div class="mobileproductleft">
      <h5>#{{details.pdetails.product_id}}</h5>
      <img :src="details.img_tag2" alt="image">
    </div>
    <div class="mobileproductRight">
      <div class="mobHeading" v-html="details.pdetails.product_name"></div>
      <div class="mobileean ean"><img src="@/images/eanicon.png" alt="image">
        <label>EAN</label>
        <span>{{details.pdetails.product_code}}</span></div>
      <div class="mobilepurchase purchasevalue" v-if="readonly">
        <div class="input-group">
          <input type="text" name="quant[1]" class="form-control input-number" v-model="oqty" min="1" disabled/>
        </div>
      </div>
      <div class="mobilepurchase purchasevalue" v-else>
        <div class="input-group">
          <span class="input-group-btn">
            <button v-on:click="addQty(-1)" type="button" class="btn btn-default btn-number" :disabled="oqty<=1" data-type="minus" data-field="quant[1]">
              <span class="glyphicon glyphicon-minus"></span>
            </button>
          </span>
          <input type="text" name="quant[1]" class="form-control input-number" v-model="oqty" min="1" v-on:keyup.enter="addQty()"/>
          <span class="input-group-btn">
            <button v-on:click="addQty(1)" type="button" class="btn btn-default btn-number" data-type="plus" data-field="quant[1]">
              <span class="glyphicon glyphicon-plus"></span>
            </button>
          </span> </div>
        <a><img src="@/images/crossimage.png" alt="image" v-on:click="remove($event)"></a>
      </div>
      <div class="mobileunitget">
        <div class="mobilegetimage">
          <div class="getfree_wrapper" v-if="unitdiscount">
            <div class="getfree_tag blue" v-on:click="!readonly && addQty(parseInt(details.wbuym))">
              <div class="label_buy">{{res.buyfree}}</div>
              <div class="txt_buy">{{details.wbuym}}</div>
              <div class="label_free" v-html="res.getfree"></div>
              <div class="txt_free">{{details.wfreen}}</div>
              <div class="box_bg"></div>
            </div>
          </div>
          <p>{{res.unittoget}}:</p>
        </div>
        <div class="mobilegetvalue"> {{qty}} </div>
      </div>
      <div class="mobilecost">
        <div class="pull-right">
          <div class="mobileunitcost"> {{unitcost}} </div>
          <div class="mobileunithkd"> {{curr}} </div>
          <div class="mobileunithkdvalue">{{details.wprice | format()}} </div>
        </div>
      </div>
    </div>
    <!------>
  </div>
  <!---2----->
  <div class="mobdiscount">
    <div class="monnextbox">
      <div class="pull-left" v-if="dis_shown != null && dis_shown.length > 0">
        <div class="mobdis">{{res.discount}} <img src="@/images/discountarrow.png" alt="image"></div>
      </div>
      <div class="pull-right">
        <div class="mobdistotal">
          <p>{{res.subtotal}}</p>
          <span> {{curr}} </span> 
          <!--
          <span v-if="total != null"> {{total | format()}} </span>
          <span v-else> {{subtotal | format()}} </span>
          -->
          <span :s="JSON.stringify(details)" v-if="details.subtotal != null"> {{details.subtotal | format()}} </span>
          <span s="b" v-else-if="total != null"> {{total | format()}} </span>
          <span s="c" v-else> {{subtotal | format()}} </span>
        </div>
      </div>
    </div>

    <div class="monnextbox" v-for="(discount, didx) in dis_shown" v-if="discount.prefix == null || discount.prefix != 'FG'">
      <div class="mobtrade">
        <label v-if="discount.calamt == null"> {{res.fgdesc}}: </label>
        <label v-else> {{discount.name}}: </label>
        <span v-if="discount.dprice > 0"> +{{(discount.calamt * 100) | format('0.0')}} % </span>
        <span v-else-if="discount.prefix == 'TD'"> {{(discount.calamt * -1 * 100) | format('0.0')}} % </span>
        <span v-else-if="discount.prefix == 'SP'"> {{(discount.calamt * -1 * 100) | format('0.0')}} % </span>
        <span v-else-if="discount.ctype == 'PT'"> {{(discount.calamt * -1 * 100) | format('0.0')}} % </span>
        <span v-else-if="discount.ctype != null && discount.ctype.indexOf('FP@') >= 0"> #{{discount.products[0].product_id}}</span>
        <span v-else-if="discount.calamt == null"> {{res.fg}} </span>
        <span v-else> {{(-1*discount.dprice)|format()}} </span>
        <!--span-- v-else> {{discount.calamt}} </!--span-->
        <p v-if="discount.dprice > 0"> +{{(discount.dprice) | format()}} </p>
        <p v-else-if="discount.prefix == 'TD'"> ({{(-1*discount.dprice) | format()}}) </p>
        <p v-else-if="discount.prefix == 'SP'"> ({{(-1*discount.dprice) | format()}}) </p>
        <p v-else-if="discount.ctype != null && discount.ctype.indexOf('FP@') >= 0"> +{{(discount.products[0].qty)}} </p>
        <p v-else> ({{(-1*discount.dprice) | format()}}) </p>
      </div>
    </div>
  </div>
  <!---3----->
  <div class="mobcasediscount" v-if="casediscount">
    <div class="mobdiscount1">
      <div class="pull-left">
        <div class="mobileunitcost1"> Case Discount </div>
      </div>
      <div class="pull-right">
        <div class="mobileunitcost"> Unit Cost </div>
        <div class="mobileunithkdvalue"> - HKD 123.00 </div>
      </div>
    </div>
    <div class="mobdiscount1">
      <div class="pull-right">
        <div class="mobileunithkdvalue"> x 2 </div>
      </div>
    </div>
    <div class="mobdiscount1">
      <div class="pull-right">
        <div class="mobileunitcost"> Sub Total </div>
        <div class="mobileunithkdvalue"> - HKD 123.00 </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>

import utils from './Utils.vue'
//import orderProduct from './OrderProduct.vue'
import cartProduct from './CartProduct.vue'

export default {
  extends: cartProduct,
  name: 'mCartProduct',
  props:['readonly']
}
</script>



// WEBPACK FOOTER //
// src/components/MCartProduct.vue